export default __webpack_public_path__ + "062df4ccd2e15fd6db9eb8179ab33a83.svg";